import { Languages } from "lucide-react";

export const LanguageToggle = ({ language, onChange }) => {
  return (
    <div
      className="glass-card inline-flex items-center gap-2 rounded-full px-2 py-2"
      data-testid="language-toggle"
    >
      <span className="rounded-full bg-primary/10 p-2 text-primary" data-testid="language-toggle-icon">
        <Languages className="h-4 w-4" />
      </span>
      <button
        className={`rounded-full px-4 py-2 text-xs font-semibold uppercase tracking-[0.25em] transition-colors duration-300 ${
          language === "en" ? "bg-primary text-background" : "text-slate-300 hover:text-primary"
        }`}
        data-testid="language-toggle-en-button"
        onClick={() => onChange("en")}
        type="button"
      >
        EN
      </button>
      <button
        className={`rounded-full px-4 py-2 text-xs font-semibold uppercase tracking-[0.25em] transition-colors duration-300 ${
          language === "it" ? "bg-primary text-background" : "text-slate-300 hover:text-primary"
        }`}
        data-testid="language-toggle-it-button"
        onClick={() => onChange("it")}
        type="button"
      >
        IT
      </button>
    </div>
  );
};